module.exports = __webpack_public_path__ + "media/entities/1501-d7871ca7.png";